import React, { FunctionComponent, useState, useEffect, PropsWithChildren } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { ILogModalProps } from 'src/models/components/ILogModal'
import Spinner from 'src/components/Spinner'
import downloadIcon from '../assets/images/svgs/download-icon.svg'
import Ansi from 'ansi-to-react'
import { canDownloadLogs, LOGS_DOWNLOAD_UNAVAILABLE_MESSAGE } from 'src/utils/jobStatus'

const LogModal: FunctionComponent<ILogModalProps> = (props: PropsWithChildren<ILogModalProps>) => {
  const [ready, setReady] = useState(false)
  useEffect(() => {
    setReady(false);
    if (props.job.status !== 'RUNNING' && props.job.status !== 'QUEUED' && props.logArray.length) setReady(true)
    else if (props.logArray.length || props.taskId) setReady(true)

    // show the spinner for a maximum of 5 seconds
    const timeoutId = setTimeout(() => {
      setReady(true);
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, [props.logArray.length, props.taskId, props.job.status])

  return (
        <>
            <Dialog
              open={props.show}
              onClose={props.hideLog}
              scroll='paper'
              aria-labelledby="logs-title"
              aria-describedby="logs-body"
              maxWidth='xl'
              fullWidth={true}
            >
                <div id="logs-title" className="modal-header">
                  <div className="log-modal-title modal-title h4">
                  {props.job?.status}
                    {canDownloadLogs(props.job.status)
                      ? (
                        <span className="log-download-button" onClick={() => props.downloadLog(props.job)}>
                            <img
                                style={{ cursor: 'pointer' }}
                                src={downloadIcon}
                                alt="Download logs"
                                title="Download logs"
                            />
                            Download
                        </span>
                        )
                      : (
                        <span className="log-download-unavailable">{LOGS_DOWNLOAD_UNAVAILABLE_MESSAGE}</span>
                        )}
                  </div>
                  <div className="content-center close-button">
                    <button name="close" className="close"
                        onClick={props.hideLog}>
                        <span aria-hidden="true">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                  </div>
                </div>
                <DialogContent dividers={true} style={{ height: '100vh', padding: '16px 8px' }}>
                  <div
                    id="logs-body"
                    tabIndex={-1}
                  >
                      {ready
                      ? (
                          props.logArray.length
                            ? (
                                <>
                                {props.logArray[0]?.sequence > 0 &&
                                  <div className="log-data-row log-truncation-notice">
                                    <code>Showing only the last {props.logArray.length.toLocaleString()} log lines — use Download to get the full log</code>
                                  </div>}
                                {props.logArray.map((log: any, index: number) => {
                                  return (
                                    <div className="log-data-row" key={index}>
                                        <code
                                            className="log-sequance"
                                            data-unselectable={`${log.sequence} |`} />
                                        <code
                                            className="log-timestamp"
                                            data-unselectable={`${log.timestamp} |`} />
                                        <Ansi>{log.message}</Ansi>
                                    </div>
                                  )
                                })}
                                </>
                              )
                            : (
                            <div>No logs yet</div>
                              )
                        )
                      : (
                        <div className="content-center">
                          <Spinner active={true}>&nbsp;</Spinner>
                        </div>
                        )}
                  </div>
                </DialogContent>
            </Dialog>        </>
  )
}

export default LogModal
